declare namespace $ {

	type $mol_paragraph__title_easyreels_user_signin_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_button_major__title_easyreels_user_signin_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_easyreels_user_signin_3 = $mol_type_enforce<
		ReturnType< $easyreels_user_signin['start'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	export class $easyreels_user_signin extends $mol_view {
		Lead( ): $mol_paragraph
		Start( ): $mol_button_major
		start( next?: any ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=signin.view.tree.d.ts.map